import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import {App} from './Processing/Testing/App_test'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

